export default function ({ language }) {
  var config = {
    label: language['bank-account-label'],
    placeholder: language['bank-account-placeholder'],
    format: 'integer',
    maxLength: 11,
    validators: ['mandatory', 'numberOfDigits:11'],
  };

  return {
    config,
    extendsType: 'text-field',
    validators: [
      function bankAccount(state, config) {
        if (validateBankAccount(state.value)) return false;
        else return language['bank-account-invalid'];
      },
    ],
  };
}

function validateBankAccount(number) {
  return number.length === 11 && number !== '00000000000' && controlDigit(number) == number[10];
}

function controlDigit(identificationNumber) {
  var products = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  var sum = products
    .map((product, index) => {
      return product * identificationNumber[index];
    })
    .reduce((a, b) => a + b);
  var digit = 11 - (sum % 11);
  return digit === 11 ? 0 : digit;
}
